import angular from 'angular';

angular.module('myConsultApp').directive('viewMoreRow', () => {
  return {
    templateUrl: 'templates/v2/view-more-row.html',
    restrict: 'E',
  };
});
